import {faker} from "@faker-js/faker";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";

export default function PointsEarnedPerPoll({isMyPolls}) {
  return <>{isMyPolls && <>
    <Stack direction="row" spacing={1} justifyContent="space-around"
           alignItems="center" sx={{pb: 1}}>
      <Chip label={`${faker.number.int({min: 10, max: 400})} Points(v1)`} color="primary"/>
      <Chip label={`Earning(V2) - ₹${faker.number.int({min: 0, max: 10})}`} color="primary"/>
    </Stack>
  </>}</>
}
